














import Debug from "debug";
import debounce from "lodash-es/debounce";
import Vue from "vue";
import FontLoader from "@/mixins/FontLoader";
import CommonHeader from "@/components/CommonHeader.vue";
import PartnerHeader from "@/components/PartnerHeader.vue";
import CommonFooter from "@/components/CommonFooter.vue";
import CookieConsent from "@/components/CookieConsent.vue";

const log = Debug("legend");

export default Vue.extend({
  name: "App",

  metaInfo: {
    title: "Legend Trading",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Legend Trading is a leading U.S. regulated crypto trading firm trusted by 700+ institutional clients, with $10billion+ trading volume per year. Its over-the-counter (OTC) trading service offers deep liquidity and customizable services that are suited for brokerage firms, investment advisors, family offices, corporations, and high net-worth individuals. Legend Trading also offers a comprehensive fiat-to-crypto gateway for banks, crypto exchanges, wallets, and NFT platforms to integrate and enable their customers to buy/sell crypto with bank transfer and credit/debit cards."
      }
    ]
  },

  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false
    };
  },

  props: {},

  mixins: [FontLoader],

  components: {
    // [BackTop.name]: BackTop,
    PartnerHeader,
    CommonHeader,
    CommonFooter,
    CookieConsent
    // SvgArrow
  },

  computed: {
    hideContent(): boolean {
      const { name, path } = this.$route;
      return name === null && path === "/";
    },
    showPartnerHeader(): boolean {
      const { meta } = this.$route;
      return meta?.header === "partner";
    },
    hideFooter(): boolean {
      const { meta } = this.$route;
      return meta?.footer === "hide";
    }
  },

  watch: {
    "$route.meta.background": {
      handler(val) {
        if (val === "grid") {
          document.documentElement.setAttribute("style", "");
        } else if (val === "grid-upper") {
          document.documentElement.setAttribute(
            "style",
            "background-position: 50% -23px"
          );
        } else {
          document.documentElement.setAttribute(
            "style",
            "background-image: none"
          );
        }
      },
      immediate: true
    },
    updateExists: {
      handler(val) {
        if (val) {
          const $el: HTMLElement = this.$awn.info(
            "New content available! <br>Click to update"
          );
          $el.addEventListener("click", this.refreshApp, { once: true });
        }
      },
      immediate: true
    }
  },

  methods: {
    updateVh: debounce(() => {
      const vh = window.innerHeight * 0.01;
      log("update :root --vh, %s", vh);
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }, 500),
    showRefreshUI(e: Event) {
      this.registration = (e as CustomEvent).detail;
      this.updateExists = true;
    },
    refreshApp() {
      this.updateExists = false;
      const { waiting = null } = this.registration || { waiting: null };
      if (waiting) {
        (waiting as any).postMessage("skipWaiting");
      }
    }
  },

  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      });
    }
  },

  mounted() {
    // this.updateVh();
  }
});
